import { ApplicationFormSchema } from "./schemas";
import ApplicationJson from "./formDefs/Application.json";
import { ControlDefinition, SchemaField } from "@react-typed-forms/schemas";

export const Application = {
  value: "Application",
  name: "Application",
  schema: ApplicationFormSchema,
  schemaName: "ApplicationForm",
  defaultConfig: null,
  controls: ApplicationJson.controls as ControlDefinition[],
  config: ApplicationJson.config,
  formFields: ApplicationJson.fields as SchemaField[],
};

export const FormDefinitions = {
  Application: Application,
};
